import React, { useContext, useEffect, useMemo, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { BotMessageModal } from "../BotMessageModal";
import { BotStartModal } from "../BotStartModal";
import { Login } from "../Login";
import { SiteHeader } from "../SiteHeader";
import { BotStore } from "../Store";
import { Bot, BotStatus, listBots, userInfo } from "../bot-loaders";
import { Modal } from "../components/Modal";
import { MessageBox } from "../comps/MessageBox";
import { ReactTooltip } from "tooltip";
import { Image } from "../components/Image";
import { useAlert } from "../components/Dialogs";
import { Alert } from "../components/Alert";
import { HelpModal } from "./HelpModal";
import { DarkModeToogle } from "../components/dark-mode";

function DefaultPicture(){
    var style = {width:"50px", height:"50px", background: "var(--bs-primary)", color: "white"};
    return <div className="rounded-circle me-2 d-flex align-items-center justify-content-center" style={style}><i className="fa fa-user"></i></div>;
}

export function BotPicture({bot}:{bot:Bot}){
    var style = {width:"50px", height:"50px", background: "var(--bs-primary)", color: "white"};
    if(bot.picture) 
        return <Image src={bot.picture} style={style} className="rounded-circle me-2" alt="Imagem" fallback={<DefaultPicture />} /> 
    return <DefaultPicture />
}

function BotItem({bot}:{bot:Bot}){
    const [show, setShow] = useState(false);
    const navigate = useNavigate();
    const alert = useAlert("Este bot está suspenso na plataforma.", {});

    function onClick(){
        if(bot.name.startsWith("*")){
            alert();
            return;
        }

        if(bot.status != 'online')
            return setShow(true)
        navigate(`/bot/${bot.id}`);
    }

    return <>
        <div className={`bot-item d-flex mb-3 ${bot.name.startsWith('*') ? ' opacity-50' : ''}`}  style={{cursor:'pointer'}} onClick={onClick}>
            <BotPicture bot={bot} />
            <div>
                {bot.name.replace(/\* /, "")} <br />
                <small className="text-muted">{BotStatus[bot.status]}{bot.status == 'online' && <span className="opacity-75">{" ("}{bot.phone}{")"}</span>}</small>
            </div>
        </div>
        {show && <Modal title={bot.name} onHide={() => setShow(false)}>
                <BotStartModal bot={bot} />
            </Modal>}
    </>
}

export function BotList(){
    const ctx = useContext(BotStore);
    const {bots} = ctx.state
    const navigate = useNavigate();
    const [showHelp, setShowHelp] = useState(false);
    
    useEffect(function(){
        (async () => {
            try{
                const result = await listBots();
                const session = await userInfo();
                ctx.dispatch({type: "setBots", payload: result});
                ctx.dispatch({type: "setSession", payload: session});
            }catch(e){
                if(e == 'login-required')
                    ctx.dispatch({type: "setNeedsLogin", payload: true});
            }
        })()
    }, [ctx.state.needsLogin == false])

    if(ctx.state.needsLogin)
        return <Login />

    if(bots == null)
        return <div className="loader">Carregando...</div>

   /* if(!bots.find(b => b.id == 1))    
        return <>
        <div className="container my-4">
            <SiteHeader />
            <Alert className="alert-warning mx-450" content={<><b>Atenção: </b> Estamos atualizando o sistema e em breve retornaremos</>} />
        </div>    
        </>*/

    return <>
        <div className="container my-4">
            <SiteHeader />
            <h4 className="mb-3">Meus Bots <small>(Números de WhatsApp)</small></h4>
            <div className="bot-list mt-4">
                {bots.map(b => <BotItem key={b.id} bot={b} /> )}
            </div>
            <BotHintMessage />
            {/* <Alert className="alert-warning mx-450" content={<><b>Atenção: </b> Atualmente o whatsapp está atualizando e o envio de vídeo está limitado. Opte por usar imagens e textos bem elaborados 😉</>} /> */}

            <h4 className="mt-4 mb-3">Recursos</h4>
            <ReactTooltip className="mb-2 me-2 align-top" delay={300} placement="top-start" tooltip={<>Crie a Atualize o <b>Público-Alvo</b> das campanhas</>}>
                <button className="btn btn-primary" onClick={() => navigate("/publico")}><i className="fa fa-users"></i> Gerenciar Público</button>
            </ReactTooltip>
            <ReactTooltip className="mb-2 me-2 align-top" delay={300} tooltip={<>Gerencie as <b>imagens</b> e <b>áudios</b> que deseja usar nas campanhas</>}>
                <button className="btn btn-primary" onClick={() => navigate("/midia")}><i className="far fa-images"></i> Gerenciar Mídias</button>
            </ReactTooltip>
            <DarkModeToogle />
            <button className="btn btn-primary" onClick={() => setShowHelp(true)}><i className="far fa-circle-question"></i> Ajuda</button>
        </div>
        {showHelp && <Modal className="modal-xl" onHide={() => setShowHelp(false)} title={<><i className="far fa-circle-question"></i> Ajuda</>}><HelpModal /></Modal>}
    </>
}

function BotHintMessage(){
    const {state:{bots}} = useContext(BotStore);
    const connectedBots = useMemo(function(){return bots.filter(b => b.status == 'online')}, [bots])

    if(connectedBots.length == 0) 
        return <MessageBox icon="fa fa-check" className="mx-450">
        <div className="mb-2">Você ainda não tem nenhum bot conectado.</div>
        Clique no <b>bot</b> desejado para conecta-lo ao seu número de WhatsApp e começar a enviar suas mensagens automatizadas.
    </MessageBox>

    return <MessageBox icon="fa fa-check" className="mx-450">
        <div className="mb-2">Agora você tem <b>{connectedBots.length} bot(s) conectado(s).</b></div>
        Clique no <b>bot</b> desejado para enviar mensagens para algum de seus públicos predefinidos.
    </MessageBox>
}